import React from "react";
import {Website} from "../layouts/Website";
import {Box, Container, Typography} from "@mui/material";
import {PageTitle} from "../components/shared/PageTitle";
import {contactsMap} from "../assets/data/contactsMap";

export const Contacts = () => {
    return (
        <Website>
            <Container maxWidth={'xxl'} sx={{pb: 2, pt: 6}}>
                <PageTitle title={'contatti'} image={'icon-contacts'}/>
                <Typography sx={{textDecoration: 'underline', py:1}} fontWeight={'bold'} variant={'h6'}>
                    Numeri attivi dal 21/09 al 23/09
                </Typography>
                <Box>
                    {
                        contactsMap.map((contact, index) =>
                            <Box key={index} sx={{py:1}}>
                                <Typography variant={'h6'} fontWeight={'bold'} color={'#2F6CB4'}>
                                    {contact.title}
                                </Typography>
                                {contact.description && <Typography>
                                    {contact.description}
                                </Typography>}
                                {
                                    contact.list &&
                                    <ul style={{marginBlock:0}}>
                                        {contact.list.map((item, index) =>
                                            <li key={index}>
                                                <Typography>
                                                    {item}
                                                </Typography>
                                            </li>
                                        )}
                                    </ul>
                                }
                            </Box>
                        )
                    }
                </Box>
            </Container>
        </Website>
    )
}
